import styled from "styled-components";
import ListPage from "../../../customUiForCs/ListPage";
import CommentCard from "./CommentCard";
import { useContext, useEffect } from "react";
import Context from "../../../../Context";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import NomenclatureOfComment from "../nomenclature/NomenclatureOfComment";
import { serverLine } from "../../../../controllers/network/serverLine";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  width: 100%;
  margin-top: 30px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const Content = styled.div`
  padding: 15px;
  border: 1px solid var(--borderDim);
  background: var(--surface2);
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const BottomPart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export default function CommentListPage() {
  const { setUnseenCommentsCount } = useContext(Context);

  useEffect(() => {
    setUnseenCommentsCount(0);
    serverLine.post("/reset-comment-notifications");
  }, []);

  return (
    <LoggedInBoilerplate titleLine1={"Liste de"} titleLine2={"Commentaires"}>
      <NomenclatureOfComment />
    </LoggedInBoilerplate>
  );
}
